import { render, staticRenderFns } from "./ChannelCardBack.vue?vue&type=template&id=09664dfa&scoped=true"
import script from "./ChannelCardBack.vue?vue&type=script&lang=js"
export * from "./ChannelCardBack.vue?vue&type=script&lang=js"
import style0 from "./ChannelCardBack.vue?vue&type=style&index=0&id=09664dfa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09664dfa",
  null
  
)

export default component.exports